import { render } from "./Demo4.vue?vue&type=template&id=90811e0c&scoped=true&ts=true"
import script from "./Demo4.vue?vue&type=script&lang=ts"
export * from "./Demo4.vue?vue&type=script&lang=ts"

import "./Demo4.vue?vue&type=style&index=0&id=90811e0c&lang=scss&scoped=true"

import exportComponent from "/Users/suhwanlim/Projects/pr/MoTobi-Web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90811e0c"]])

export default __exports__